module.exports = __webpack_public_path__ + "img/tall.760a3ee4.svg";